import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import MyNavbar from "./Components/Navbar/Navbar";
import Banner from "./Components/Banner/Banner";
import "./App.css"
import FeatureSection from "./Components/FeatureSection/FeatureSection";
import AdvancedCare from "./Components/AdvancedCare/AdvancedCare";
import FeaturedProducts from "./Components/FeaturedProducts/FeaturedProducts";
import Articles from "./Components/Articles/Atricles";
import Footer from "./Components/Footer/Footer";


function App() {
  return (
    <Router>
      <MyNavbar />
      <Banner />
      <FeatureSection />
      <AdvancedCare />
      <FeaturedProducts />
      <Articles />
      <Footer />
    </Router>
  );
}

export default App;
